// AI Generated Service
import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { mergeDeep, safeClone } from '@client/app/shared/utils/object-utils';
import { DocumentDetailsComponent } from '@client/app/components/documentdetails/details/document-details.component';

/**
 * Component Details View Service
 */
@Injectable({
    providedIn: 'root',
})
export class ComponentDetailsViewService {
    constructor (
        private monEventService: MonEventService,
    ) {}

    /**
     * Navigate to document details
     */
    goToDocumentDetails (document: any, dataParams?: any, cb?: () => void): void {
        const data = mergeDeep(
            safeClone({
                document: document,
            }),
            dataParams,
        );

        const params = {
            body: DocumentDetailsComponent,
            size: 'page-details',
            classes: 'document-details-app',
            data: data,
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: cb });
    }
}
